export function utf8ToBase64(str: string) {
  // 1. Encode the UTF-16 JavaScript string to a Uint8Array of UTF-8 bytes
  const textEncoder = new TextEncoder();
  const utf8Bytes = textEncoder.encode(str);

  // 2. Convert the Uint8Array to a "binary string" that btoa can handle
  //    (each byte becomes a character with the corresponding code point)
  const binaryString = String.fromCodePoint(...utf8Bytes);

  // 3. Base64 encode the binary string
  return btoa(binaryString);
}

export function base64ToUtf8(base64: string) {
  // 1. Base64 decode the string to a "binary string"
  const binaryString = atob(base64);

  // 2. Convert the "binary string" back to a Uint8Array of bytes
  //    (each character's code point becomes a byte)
  const utf8Bytes = Uint8Array.from(binaryString, (m) => m.charCodeAt(0));

  // 3. Decode the UTF-8 bytes to a UTF-16 JavaScript string
  const textDecoder = new TextDecoder('utf-8');
  return textDecoder.decode(utf8Bytes);
}
